import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { BatchPoolCycleRunContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_my_einvoice_batch_pool_cycle_run_hdr.model';

@Injectable({
  providedIn: 'root'
})
export class BatchPoolCycleRunService extends BaseApiTemplateService<BatchPoolCycleRunContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/batch-pool-cycle-run-hdrs/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/batch-pool-cycle-run-hdrs/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/batch-pool-cycle-run-hdrs/backoffice-ep'
    this.httpClient = http;
  }
}
